module.exports = __webpack_public_path__ + "img/button4.928b52ad.png";